//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfOverlay from "../../atoms/SfOverlay/SfOverlay.vue";
import SfTransition from "../../../utilities/transitions/component/SfTransition.js";
import SfHeading from "../../atoms/SfHeading/SfHeading.vue";
import SfButton from "../../atoms/SfButton/SfButton.vue";
import SfCircleIcon from "../../atoms/SfCircleIcon/SfCircleIcon.vue";
import { isClient } from "../../../utilities/helpers";
export default {
  name: "SfBottomModal",
  components: { SfOverlay, SfButton, SfCircleIcon, SfHeading, SfTransition },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    transition: {
      type: [String, Boolean],
      default: "",
    },
  },
  watch: {
    isOpen: {
      handler(value) {
        if (!isClient) return;
        if (value) {
          document.addEventListener("keydown", this.keydownHandler);
        } else {
          document.removeEventListener("keydown", this.keydownHandler);
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit("click:close");
    },
    keydownHandler(e) {
      if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
        this.close();
      }
    },
  },
};
